import { NEAR_WHITE, LIGHTER_GRAY } from "@shape/reef-shared";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: relative;
  font-size: 13px;
  color: ${NEAR_WHITE};
  margin-left: 16px;
  margin-right: 2rem;
`;

export const UserMenuGreeting = styled.div<{ isMenuOpen: boolean }>`
  gap: 8px;
  display: flex;
  margin-left: 8px;
  cursor: pointer;
  transition: 0.2s ease;
  outline: none;
  pointer-events: ${({ isMenuOpen }) => (isMenuOpen ? "none" : "unset")};
  color: ${LIGHTER_GRAY};
`;

export const SignIn = styled.div`
  margin-left: 16px;
  font-size: 13px;
  font-weight: bold;
  color: ${NEAR_WHITE};
  cursor: pointer;
  outline: none;
`;
